"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var closeIcon_svg_1 = __importDefault(require("./closeIcon.svg"));
var useStyles = (0, react_jss_1.createUseStyles)({
    close: function (fullscreen) { return ({
        background: 'none',
        padding: 0,
        border: 'none',
        position: 'absolute',
        top: fullscreen ? 26 : 12,
        right: fullscreen ? 26 : 12,
        zIndex: 10,
        cursor: 'pointer',
        '& img': { verticalAlign: 'top' },
    }); },
});
var ModalCloseButton = function (_a) {
    var onClose = _a.onClose, fullScreen = _a.fullScreen;
    var styles = useStyles(fullScreen);
    return (react_1.default.createElement("button", { "aria-label": "Close", onClick: onClose, className: styles.close },
        react_1.default.createElement("img", { src: closeIcon_svg_1.default, alt: "" })));
};
exports.default = ModalCloseButton;
//# sourceMappingURL=ModalCloseButton.js.map